import { TextField } from '@mui/material'
import React from 'react'

export const CustomTextField = ({ register, label, ...rest }) => {
  return (
    <TextField
      sx={{ bgcolor: 'white', margin: '7px 0' }}
      id="filled-basic"
      label={label}
      size="small"
      InputLabelProps={{
        shrink: true,
      }}
      {...register}
      {...rest}
    />
  )
}
